/*import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:8000/api", // change to your Laravel API URL
  headers: {
    Accept: "application/json",
  },
});

export default api;
*/
//C:\xampp\htdocs\pms2\frontend\src\services\api.ts

/*
import axios from "axios";

const api = axios.create({
  baseURL: "http://127.0.0.1:8000/api",
  timeout: 30000,
  headers: {
    Accept: "application/json",
  },
});

// REQUEST INTERCEPTOR (Auth only) /
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// RESPONSE INTERCEPTOR (ERRORS ONLY) /
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ECONNABORTED") {
      console.error("Request timeout");
    }
    if (!error.response) {
      console.error("Server unreachable");
    }
    return Promise.reject(error);
  }
);

export default api;
*/

import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // ✅ dynamic
  timeout: 30000,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ECONNABORTED") {
      console.error("Request timeout");
    }
    if (!error.response) {
      console.error("Server unreachable");
    }
    return Promise.reject(error);
  }
);

export default api;



